import { render, staticRenderFns } from "./BottomNavTabs.vue?vue&type=template&id=fa7cf51e&scoped=true"
import script from "./BottomNavTabs.vue?vue&type=script&lang=js"
export * from "./BottomNavTabs.vue?vue&type=script&lang=js"
import style0 from "./BottomNavTabs.vue?vue&type=style&index=0&id=fa7cf51e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa7cf51e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\JSH\\Desktop\\workspace\\yueqitong\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa7cf51e')) {
      api.createRecord('fa7cf51e', component.options)
    } else {
      api.reload('fa7cf51e', component.options)
    }
    module.hot.accept("./BottomNavTabs.vue?vue&type=template&id=fa7cf51e&scoped=true", function () {
      api.rerender('fa7cf51e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/public/components/tabs/BottomNavTabs.vue"
export default component.exports